import { IconProps } from './types';

const CollapseIcon = (props: IconProps) => {
  const { width = '24', height = '24', fillColor = '#0276FE' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
    >
      <mask
        id="mask0_1249_58231"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={width}
        height={height}
      >
        <rect width={width} height={height} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1249_58231)">
        <path
          d="M9.99999 15.3998L4.09999 21.2998C3.91665 21.4831 3.68332 21.5748 3.39999 21.5748C3.11665 21.5748 2.88332 21.4831 2.69999 21.2998C2.51665 21.1165 2.42499 20.8831 2.42499 20.5998C2.42499 20.3165 2.51665 20.0831 2.69999 19.8998L8.59999 13.9998H4.99999C4.71665 13.9998 4.47915 13.904 4.28749 13.7123C4.09582 13.5206 3.99999 13.2831 3.99999 12.9998C3.99999 12.7165 4.09582 12.479 4.28749 12.2873C4.47915 12.0956 4.71665 11.9998 4.99999 11.9998H11C11.2833 11.9998 11.5208 12.0956 11.7125 12.2873C11.9042 12.479 12 12.7165 12 12.9998V18.9998C12 19.2831 11.9042 19.5206 11.7125 19.7123C11.5208 19.904 11.2833 19.9998 11 19.9998C10.7167 19.9998 10.4792 19.904 10.2875 19.7123C10.0958 19.5206 9.99999 19.2831 9.99999 18.9998V15.3998ZM15.4 9.9998H19C19.2833 9.9998 19.5208 10.0956 19.7125 10.2873C19.9042 10.479 20 10.7165 20 10.9998C20 11.2831 19.9042 11.5206 19.7125 11.7123C19.5208 11.904 19.2833 11.9998 19 11.9998H13C12.7167 11.9998 12.4792 11.904 12.2875 11.7123C12.0958 11.5206 12 11.2831 12 10.9998V4.9998C12 4.71647 12.0958 4.47897 12.2875 4.2873C12.4792 4.09564 12.7167 3.9998 13 3.9998C13.2833 3.9998 13.5208 4.09564 13.7125 4.2873C13.9042 4.47897 14 4.71647 14 4.9998V8.5998L19.9 2.6998C20.0833 2.51647 20.3167 2.4248 20.6 2.4248C20.8833 2.4248 21.1167 2.51647 21.3 2.6998C21.4833 2.88314 21.575 3.11647 21.575 3.3998C21.575 3.68314 21.4833 3.91647 21.3 4.0998L15.4 9.9998Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default CollapseIcon;
